import Database from '../../containers/database/index'
import AppShell from '../../components/layout/AppShell'

export default function DatabasePage() {
    return (
        <AppShell title="База данных">
            <Database />
        </AppShell>
    )
}
